export enum LBTDividerSize {
  SMALL = '1px',
  MEDIUM = '2px',
}
